import Vue from 'vue';
import log from './customLog.js'
import api from '@api'

export default class Contact {
    constructor(options) {
        this.cache(options)
        this.init()

        return this
    }
                
    cache(options) {
        this.settings = Vue.observable({
            ...this.defaults,
            ...options
        });

        this.console = new log({name: '[contact]'})
    }
                
    get defaults() {
        return {
            plugin: null,
            janinfo: null,
            id: null,
            client: {
                number: null,
            },
            company: {
                name: null,
                number: null,
                settings: ''
            },
            onremvoed: false,
            transferring: false,
            audio: {
                isMicMute: true,
            },
            accepted: false,
            janus: null,
            reason: null
        }
    }
                
    init() {
        this.initId()
        const {result} = this.settings.janinfo.msg
        switch (result.event) {
            case 'incomingcall':
                this.initIncCallContact(result)
                break
            case 'calling':
                this.initCallContact(result)
                break
        }
    }

    initCallContact(result) {
        const number = this.getClientNumber(result)
        this.settings.client.number = number
    }
    initIncCallContact(result) {
        // if(!result.displayname) {
        //     result.displayname = `"{'company_id':'12','agent_id':'1024 101 102 1023 103 ','client':'+00000000000','type':'', 'transfer':'true', 'externall_call_id':'1724417211.509'}"`
        //   "displayname": "\"{'company_id':'12','agent_id':'779 101 102 1023 103 ','client':'+77470947120','type':'', 'transfer':'true', 'externall_call_id':'1724233900.75'}\"",
        // }
        
        const data = this.parseData(result.displayname)
        this.settings.external_call_id = data.external_call_id || data.externall_call_id
        this.settings.client.number = data.client
        this.settings.transfer = data.transfer

        
        this.console.log(this.settings.external_call_id )

        this.getCompany(data.company_id).then((res) => {
            this.settings.company.settings = res
            this.settings.company.name = res.company_name
        })
    }

    parseData(data) {
        if(!data) return ''
        return JSON.parse(data.replaceAll('"','').replaceAll('\'','"'))
    }

    

    fillInfo() {
    }

    initId() {
        this.settings.id = this.settings.janinfo.msg.call_id || this.settings.janinfo.msg.result.call_id
    }

    async getCompany(id) {
        try {
            const res = await api.chat.telephonyTreatmentIncomingNumber({ company_id: id});

            // {
            //     "can_change_company": true,
            //     "profile_id": 1250,
            //     "user_id": 872,
            //     "company_id": 70,
            //     "company_name": "АЛГА"
            // }
            this.console.log('getCompany',res);
            
            return res.response;
        } catch (error) {
            this.console.error('getCompany', error, this.settings);
        }
    }

   

    

    //client
     
    getClientNumber(result) {
        const username = result.username
        if(!username) {
            this.console.error('no username', {janinfo: this.settings.janinfo})
            return
        }
        
        const pattern = /:(.*?)(?=@)/; // cut sip and ip
        const number = username.match(pattern)[1]
        return number
    }
    
    update(data) {
        this.plugin = data.plugin
        this.id = data.id
        this.janinfo = data.janinfo
    }
    setOnRemove(reason) {
        this.settings.onremvoed = true
        this.settings.plugin = null
        console.log('setOnRemove', reason);
        this.reason = reason
    }
    remove() {
        // this.plugin.remove()
    }

    muteMic() {
        const plugin = this.settings.plugin
        this.settings.audio.isMicMute =  true
        plugin.muteAudio()
    }

    unmuteMic() {
        const plugin = this.settings.plugin
        this.settings.audio.isMicMute =  false
        plugin.unmuteAudio()
    }

/*************  ✨ Windsurf Command ⭐  *************/
/**
 * Returns the current volume of the contact.
 * @returns {Number} The current volume of the contact.
 * не понятно что за функция plugin.getVolume
 * plugin.getVolume = function(mid, result) 
 * mid - это Media ID (идентификатор трека) из WebRTC (обычно приходит из SDP или RemoteStream).
 */
/*******  1a60bdca-a8e0-4371-97df-040f20158870  *******/
    getVolume() {
        const plugin = this.settings.plugin
        return plugin.getVolume()
    }
    
    get id() {
        return this.settings.id
    }

    set id(value) {
        this.settings.id = value
    }

    get number() {
        // client.number отсутствует, если displayname не пришёл или не распарсился
        const raw = this.settings.client.number
        if(!raw) return ''
        let ret = raw
        if(ret.indexOf("*") !== -1 ) {
            ret = raw.split('*')[1]
        }
        return ret
    }

    get name () {
        return this.settings.client.name
    }

    get plugin () {
        return this.settings.plugin
    }

    set plugin (value) {
        this.settings.plugin = value
    }

    get janinfo () {
        return this.settings.janinfo
    }

    set janinfo (value) {
        this.settings.janinfo = value
    }

    get transferring () {
        return !!this.settings.transferring || this.settings.transfer == 'true'
    }

    get company () {
        return this.settings.company 
    }

    get client () {
        return this.settings.client
    }

    get callId () {
        return this.settings.janinfo.msg.call_id
    }

    get audio () {
        return this.settings.audio
    }

    set audio (value) {
        this.settings.audio = value
    }

    get ipPort () {
        return this.settings.janus.ipPort
    }

    get accepted () {
        return this.settings.accepted
    }

    set accepted (value) {
        this.settings.accepted = value
    }

    get call_id () {
        return this.settings.janinfo.msg.call_id
    }    

    get reason () {
        return this.settings.reason
    }

    set reason (value) {
        this.settings.reason = value
    }

    get external_call_id () {
        return this.settings.external_call_id
    }
}